var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDashboardDefault = function SvgDashboardDefault(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "atom/icon/navigation/dashboard/default")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atom/icon/navigation/dashboard/default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-6",
    transform: "translate(23.000000, 23.000000)",
    stroke: "#353531",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.09090909,0 C1.09090909,0 0,0 0,1.05882353 L0,7.94117647 C0,7.94117647 0,9 1.09090909,9 L6.54545455,9 C6.54545455,9 7.63636364,9 7.63636364,7.94117647 L7.63636364,1.05882353 C7.63636364,1.05882353 7.63636364,0 6.54545455,0 L1.09090909,0 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0909091,0.0223686151 C12.0909091,0.0223686151 11,0.0223686151 11,1.12850892 L11,3.89385969 C11,3.89385969 11,5 12.0909091,5 L17.5454545,5 C17.5454545,5 18.6363636,5 18.6363636,3.89385969 L18.6363636,1.12850892 C18.6363636,1.12850892 18.6363636,0.0223686151 17.5454545,0.0223686151 C16.4545455,0.0223686151 12.1405455,-0.0279607689 12.0909091,0.0223686151 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5454545,18 C17.5454545,18 18.6363636,18 18.6363636,16.9411765 L18.6363636,10.0588235 C18.6363636,10.0588235 18.6363636,9 17.5454545,9 L12.0909091,9 C12.0909091,9 11,9 11,10.0588235 L11,16.9411765 C11,16.9411765 11,18 12.0909091,18 L17.5454545,18 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54545455,17.9776314 C6.54545455,17.9776314 7.63636364,17.9776314 7.63636364,16.8714911 L7.63636364,14.1061403 C7.63636364,14.1061403 7.63636364,13 6.54545455,13 L1.09090909,13 C1.09090909,13 0,13 0,14.1061403 L0,16.8714911 C0,16.8714911 0,17.9776314 1.09090909,17.9776314 C2.18181818,17.9776314 6.49581818,18.0279608 6.54545455,17.9776314 Z",
    id: "Stroke-7"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboardDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard-default.e2be844b.svg";
export { ForwardRef as ReactComponent };